<soft-page>
  <soft-page-header>
    <div class="flex flex-col-reverse w-full">
      <soft-step-header [steps]="steps" [currentIndex]="0" #stepper></soft-step-header>
      <soft-default-header [overline]="stepper.stepText"
                           class="px-0! pt-0! mt-0!"
                           [title]="$safeNavigationMigration(stepper.current()?.header)"
                           [subtitle]="$safeNavigationMigration(stepper.current()?.subHeader)">
      </soft-default-header>
    </div>
  </soft-page-header>

  <soft-page-panel panelStyle="plain" class="overflow-y-auto">
    <soft-page-panel-header>
      <div class=" w-full">
        <div class="flex flex-row">
          <soft-filter-and-sort
            class="w-full mt-2"
            [filterConfig]="filterConfig"
            [sortConfig]="sortConfig"
            [explorer]="explorerLieferanten">
          </soft-filter-and-sort>

          <button class="px-3 max-h-[32px] py-1.5 ml-2 text-primary font-semibold cursor-pointer self-end rounded hover:bg-surface-tertiary border border-primary text-sm" (click)="enterOrderNumber()">
            Bestellnummer
          </button>
        </div>
      </div>
    </soft-page-panel-header>


    <div [softScrollIntoView]="true" scrollBehavior="instant"></div>

    @if (explorerLieferanten.result(); as lieferanten) {

      @if ((loading$ | async) === false) {
        <div class="">
          <div class="flex flex-col">
            @for (lieferant of lieferanten; track lieferant) {
              <div
                class="soft-card rounded-sm flex flex-row w-full items-center justify-between cursor-pointer mt-3 !p-3"
                [routerLink]="['/warenuebernahme/bestellung/schritt-2']"
                [queryParams]="{idlieferant: lieferant.lieferant.id}">
                <div class="flex flex-row w-full justify-between">
                  <div class="flex flex-col w-4/5 gap-2">
                    <div class="flex flex-row w-full justify-between">
                      <div class="flex flex-col self-center gap-1">
                        @if (lieferant.lieferant) {
                          <span class="text-light text-sm">
                        {{lieferant.lieferant.lieferantennummer}}
                      </span>
                        }
                        @if (lieferant.lieferant) {
                          <span class="font-semibold">
                        {{lieferant.lieferant.kurzbez}}
                      </span>
                        }
                        @if (lieferant.anzahl) {
                          <span class="text-light text-sm">
                        {{lieferant.anzahl}} {{ (lieferant.anzahl < 2 ? '#WWS_WARENUEBERNAHME.BESTELLUNG.LABEL_OFFENE_BESTELLUNG' : '#WWS_WARENUEBERNAHME.BESTELLUNG.LABEL_OFFENE_BESTELLUNGEN') | translate}}
                      </span>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col w-1/5 items-end self-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-light">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="w-full lg:mt-2">
          <div class="flex flex-col mt-3 justify-between h-[91px] w-full soft-card !p-3 rounded-sm" *softRepeat="10">
            <div class="skeleton rounded h-4 w-20"></div>
            <div class="skeleton rounded h-4 w-28"></div>
            <div class="skeleton rounded h-4 w-20"></div>
          </div>
        </div>
      }
    }
  </soft-page-panel>
</soft-page>
